import React from 'react';
import { Tag, Typography } from 'antd';
import type { RadarRow } from './api';
import { KIND_LABEL, SOURCE_COLOR, SOURCE_SHORT, newsBadge } from './helpers';

const { Text } = Typography;

interface Props {
  items: RadarRow[];
  selectedId?: string;
  onSelect: (id: string) => void;
}

const small: React.CSSProperties = { fontSize: 11 };
const tagStyle: React.CSSProperties = { fontSize: 10, padding: '0 4px', margin: 0, lineHeight: '16px' };

function Meta({ item }: { item: RadarRow }) {
  if (item.radar === 'life') return <Text style={small}>{`카페·블로그 ${item.venueCount}곳`}</Text>;
  if (item.radar === 'trend' && item.trend)
    return <Text style={small}>{`이번 주 ${item.trend.thisWeek} (지난주 ${item.trend.lastWeek})`}</Text>;
  if (item.radar === 'community')
    return (
      <>
        {item.kind && <Text type="secondary" style={small}>{KIND_LABEL[item.kind] ?? item.kind}</Text>}
        {item.others ? <Text style={small}>{`외 ${item.others}곳`}</Text> : null}
      </>
    );
  return null;
}

const PitchList: React.FC<Props> = ({ items, selectedId, onSelect }) => (
  <div role="list">
    {items.map((item, idx) => {
      const badge = newsBadge(item.news);
      const site = item.sourceKeys[0];
      return (
        <React.Fragment key={item.id}>
        {item.single && !items[idx - 1]?.single && (
          <div style={{ padding: '10px 10px 4px', fontSize: 11, color: '#8c8c8c', background: '#fafafa', borderBottom: '1px solid #f0f0f0' }}>
            단독 글 · 아직 한 곳에서만 언급됨
          </div>
        )}
        <div
          role="listitem"
          onClick={() => onSelect(item.id)}
          style={{
            display: 'flex',
            gap: 8,
            alignItems: 'flex-start',
            padding: '9px 10px',
            cursor: 'pointer',
            borderBottom: '1px solid #f0f0f0',
            borderLeft: `3px solid ${item.hasAnalysis ? '#1677ff' : 'transparent'}`,
            background: item.id === selectedId ? '#e6f4ff' : undefined,
            opacity: item.single ? 0.7 : 1,
          }}
        >
          {item.radar === 'community' && site && (
            <span
              style={{ flexShrink: 0, fontSize: 11, color: '#fff', background: SOURCE_COLOR[site], borderRadius: 4, padding: '1px 6px', marginTop: 2 }}
            >
              {SOURCE_SHORT[site]}
            </span>
          )}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: item.hasAnalysis ? 600 : 400, wordBreak: 'keep-all' }}>{item.title}</div>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 2, flexWrap: 'wrap' }}>
              {badge && <Text style={{ ...small, color: badge.color }}>{badge.text}</Text>}
              <Meta item={item} />
              {item.searchSurge && (
                <Text style={{ ...small, color: '#d46b08' }} title="네이버 검색량이 최근 3일 급증">
                  🔍검색 급증
                </Text>
              )}
              {item.beats.map((b) => (
                <Tag key={b} color="blue" style={tagStyle}>
                  {b}
                </Tag>
              ))}
              {item.isNew && (
                <Tag color="gold" style={tagStyle}>
                  새로
                </Tag>
              )}
            </div>
          </div>
        </div>
        </React.Fragment>
      );
    })}
  </div>
);

export default PitchList;
